import { React, useEffect, useState, useContext } from 'react';
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import { API_URL } from '../../../Constant';
import { changeDateFormat, validateRolesIIPManufacturing,getAllYears,getMonthList }
 from "../../../Custom/Custom";

import { jwtDecode } from 'jwt-decode';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import { generatePDFIIP } from '../../../Custom/IIPReport/Report/ReportPdf';
import { generateExcelIIP } from '../../../Custom/IIPReport/Report/ReportExcel';
import iipTitleData from '../../../iip.json';

// Rejected list helper (supports array of codes OR array of objects containing code+reason)
const toSortedStrings = (arr) => (Array.isArray(arr) ? arr.map(v => (v ?? '').toString()) : [])
  .filter(v => v.trim() !== '')
  .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));

const getRejectedCodesText = (rejectedList) => {
  if (!Array.isArray(rejectedList)) return '';
  if (rejectedList.some((x) => x && typeof x === 'object')) {
    const codes = rejectedList
      .map((x) => x?.industrial_unit_code ?? x?.industryCode ?? x?.industry_code ?? x?.code ?? x?.itemCode ?? x?.item_code ?? x?.nic5d ?? x?.nic_5d)
      .filter((v) => v != null && String(v).trim() !== '')
      .map((v) => String(v));
    return toSortedStrings(codes).join(', ');
  }
  return toSortedStrings(rejectedList).join(', ');
};

const getRejectedReasonsText = (rejectedReasons) => {
  if (!Array.isArray(rejectedReasons)) return '';
  const reasons = rejectedReasons
    .flatMap((x) => (Array.isArray(x?.reasons) ? x.reasons : []))
    .map((v) => String(v ?? '').trim())
    .filter((v) => v !== '' && v !== '0');
  return reasons.join(', ');
};

const formatRejectedDate = (value) => {
  if (!value) return '-';
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  const dd = String(dt.getDate()).padStart(2, '0');
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const yyyy = dt.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};

const getRejectedDetailsRows = (rejectedReasons) => {
  if (!Array.isArray(rejectedReasons) || rejectedReasons.length === 0) return [];
  return rejectedReasons
    .map((item, index) => ({
      srNo: index + 1,
      industryCode: item?.industry_code ?? item?.industryCode ?? '-',
      rejectedDate: formatRejectedDate(item?.date ?? item?.rejected_date ?? item?.rejectedDate ?? '-'),
      rejectedReason: (Array.isArray(item?.reasons) ? item.reasons : [])
        .map((v) => String(v ?? '').trim())
        .filter((v) => v !== '' && v !== '0')
        .join(', ') || '-',
      rejectedBy: item?.rejected_by ?? item?.rejectedBy ?? '-',
    }))
    .filter((row) => row.rejectedReason !== '-');
};


const GetPendencyReportHQ = () => {

  const currentDate = new Date();
 
  const currentYear = currentDate.getFullYear();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  // Calculate year for previous month - if previous month is in previous year, use previous year
  const prevMonthYear = prevMonthDate.getFullYear();
 const [division, setdivision] = useState([]);
  const [district, setdistrict] = useState([]);
  const [monthName, setMonthName] = useState(prevMonthName);
  const [yearName, setYearName] = useState(prevMonthYear.toString());
  const [divisionList, setDivisionList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [totalNoofNewPendingDSLReport, settotalNoofNewPendingDSLReport] = useState([]);
  const [districtName, setdistrictName] = useState([]);
  const [divisionName, setdivisionName] = useState([]);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [rejectedDetailsRows, setRejectedDetailsRows] = useState([]);
  const [rejectedModalTitle, setRejectedModalTitle] = useState('Rejected Details');
  const token = useContext(MyContextProvider).token;
  const navigate = useNavigate();
  const userlevelLogin = jwtDecode(token).id.USER_LEVEL_LOCATION;
 const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };




  const userLevel = jwtDecode(token).id.USER_TYPE;
  const storedLanguage = localStorage.getItem('language');

  useEffect(() => {
    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPManufacturing(jwtDecode(token));
        if (!role) {
          alert("You are not an authorized for IIP Report");
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      }
    };

    userRole();

    const fetchDivisionList = async () => {
      try {
        const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
        const allDivision = response.data;

        if (allDivision.status) {
          setDivisionList(allDivision.data);
         }
      } catch (error) {
        console.error(error);
        showLoading(false);
      }
    };
    fetchDivisionList();
    if (userLevel === "DISTRICT LEVEL") {
      setdistrict(userlevelLogin);
    }
    if (userLevel === "DIVISION LEVEL") {
      handleDivisionChange({ target: { value: userlevelLogin } });
    }
    if (userLevel === "HEAD QUARTER") {
      getallDistrictList();
    }
    handlePendencyData(); // Fetch initial data with default filters
  }, []);

  const getallDistrictList = async () => {
    try {
      const response = await axios.get(`${API_URL}api/getallDistrictList`, config);
      const allDistrictsHQ = response.data;
      setDistrictList(allDistrictsHQ.data);
    } catch (error) {
      console.error(error);
    }
  };



  //handle button click  and onLoad event
  const handlePendencyData = async (event, overrideMonth = null, overrideYear = null) => {
    if (event) event.preventDefault();

    // Use override values if provided, otherwise use state values
    const monthToUse = overrideMonth !== null ? overrideMonth : monthName;
    const yearToUse = overrideYear !== null ? overrideYear : yearName;

    if (!yearToUse) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = division;
    let modifiedDistrict = district;

    if (Array.isArray(division) && division.length === 0) {
      modifiedDivision = "";
    }
    if (Array.isArray(district) && district.length === 0) {
      modifiedDistrict = "";
    }

    if (modifiedDivision === "00" || modifiedDistrict === "00") {
      toast.info('Data not found.', messages.COLOR_RED);
      // settotalNoofNewPendingDSLReport([]);
      return false;
    }

    const post_data = {
      "year": yearToUse,
      "division": modifiedDivision || "",
      "district": modifiedDistrict || "",
      "month": monthToUse
    };

      try {
      showLoading(true);

      const response = await axios.post(`${API_URL}api/iipReports/pendencyReport`, post_data, config);
      const pendencyData = response.data.data.GroupCodes;
     
    if (pendencyData) {
           let customItemCodes=[];
       for(let i=0;i<pendencyData.length;i++){
            let total_industry = pendencyData[i].total_industry;
            let district_name = pendencyData[i].district_name;
            let district_code = pendencyData[i].district_code;
            let division_code = pendencyData[i].division_code;
            let division_name = pendencyData[i].division_name;
            let indusCounListArrayData = pendencyData[i].indusCounListArrayData;
            let indusCounListArrayDataCount = pendencyData[i].indusCounListArrayDataCount;
            let indusRejectcounListdata = pendencyData[i].indusRejectcounListdata;
            let indusRejectcounListCount = pendencyData[i].indusRejectcounListCount;
            let rejectedReasons = pendencyData[i].rejectedReasons;
            let rejectedReasonsCount = pendencyData[i].rejectedReasonsCount;
            let acceptedIndustryListdata = pendencyData[i].acceptedIndustryListdata;
            let acceptedIndustryListCount = pendencyData[i].acceptedIndustryListCount;
            let submittedIndustryListdata = pendencyData[i].submittedIndustryListdata;
            let submittedIndustryListCount = pendencyData[i].submittedIndustryListCount;
            let industrial_unit_code = pendencyData[i].industrial_unit_code;
            let industrial_unit_name = pendencyData[i].industrial_unit_name;

              if(district_code==='00' &&  division_code==='00'){
                indusCounListArrayData=  getFourDigitNumber(indusCounListArrayData)
            }
            const customObject = {
              total_industry:total_industry,
              district_name:district_name,
              district_code:district_code,
              division_code:division_code,
              division_name:division_name,
              indusCounListArrayData:indusCounListArrayData,
              indusCounListArrayDataCount:indusCounListArrayDataCount,
              indusRejectcounListdata:indusRejectcounListdata,
              indusRejectcounListCount:indusRejectcounListCount,
              rejectedReasons: rejectedReasons,
              rejectedReasonsCount: rejectedReasonsCount,
              acceptedIndustryListdata:acceptedIndustryListdata,
              acceptedIndustryListCount:acceptedIndustryListCount,
              submittedIndustryListdata:submittedIndustryListdata,
              submittedIndustryListCount:submittedIndustryListCount,
              industrial_unit_code:industrial_unit_code,
              industrial_unit_name:industrial_unit_name
            };
          customItemCodes.push(customObject);
       }

          settotalNoofNewPendingDSLReport(customItemCodes);
      
  }

    } catch (error) {
      console.error(error);
      
    }finally{
      showLoading(false);
    }
  };



  const handleYearChange = (event) => {
    const selectedYearValue = event.target.value;
    setYearName(selectedYearValue);
  };



  const handleDistrictChange = (event) => {
    setdistrict(event.target.value);
    const _selectedTextDis = event.target.options[event.target.selectedIndex].text;
    const _districtName = _selectedTextDis === "ALL" ? "" : _selectedTextDis;
    setdistrictName(_districtName);
  };


  
  const handleDivisionChange = async (event) => {
    const selectedDivision = event.target.value;
    setdivision(selectedDivision);
    setdistrict([]);
    if (selectedDivision) {
        // If division is selected, call the API immediately
        showLoading(true);
        const post_data = {
            division_Id: selectedDivision
        };
        try {
            const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
            const allDistricts = response.data;
            if (allDistricts.status) {
                setDistrictList(allDistricts.data);
                showLoading(false);
            }
        } catch (error) {
            console.error(error);
            showLoading(false);
        }
    } else {
    
        setDistrictList([]);
    }
};


  const handleMonthChange = (event) => {
    const selectedMonth = event.target.value;
    const now = new Date();
    const currentMonthIndex = now.getMonth();
    const currentYearForMonth = now.getFullYear();
    const monthList = getMonthList();
    const selectedMonthIndex = monthList.findIndex(month => month.value === selectedMonth);
    const selectedYear = parseInt(yearName) || currentYearForMonth;
    
    // Validation: Only check month limit if selected year is current year
    // If selected year is previous year, all months are valid
    if (selectedYear === currentYearForMonth) {
      // For current year, only allow months up to current month
      if (selectedMonthIndex > currentMonthIndex) {
        toast.error('Please select a valid month.', messages.COLOR_RED);
        setMonthName(prevMonthName); // Reset month to previous month
        return;
      }
    }
    // If selected year is previous year, all months are valid (no validation needed)
    
    setMonthName(selectedMonth);
  };

 
 // Handle excel sheet Report ************************
  const handleGenerateExcel = async () => {


     let excelFileName =generateFileName('IIP_PendencyReport');
     let transformedData='';
     const excelObjectData = {
      fileName: excelFileName,
      reportType: excelFileName,
      fileType: 'xls',
      sheetName: "IIPpendencyReport",
      firstRowMergeCells: "A1:K1",
      firstRowExportDate:  changeDateFormat(new Date()),
      secondRowMergeCells: "A2:K2",
      secondRowText: `Index of Industrial Production, Uttar Pradesh`,
      thirdRowMergeCells: "A3:K3",
      thirdRowText: "Monthly Production Details",
      fourthRowMergeCells: "A4:K4",
      fourthRowText: `(Manufacturing Sector- Pendency Report)`,
      fifthRowMergeCells: "A5:K5",
      fifthRowText: `${monthName}-${yearName}`,
    };

     let total_industry = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.total_industry, 0)
     let indusCounListArrayDataCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.indusCounListArrayDataCount, 0)
     let indusRejectcounListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.indusRejectcounListCount, 0)
     let acceptedIndustryListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.acceptedIndustryListCount, 0)
     let submittedIndustryListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.submittedIndustryListCount, 0)
   


    if(userLevel === "DISTRICT LEVEL"){


        excelObjectData.firstRowMergeCells="A1:B1";
        excelObjectData.secondRowMergeCells="A2:B2";
        excelObjectData.thirdRowMergeCells="A3:B3";
        excelObjectData.fourthRowMergeCells="A4:B4";
        excelObjectData.fifthRowMergeCells="A5:B5";
        excelObjectData.headerEnglishColumns=[
        'Industry Name', 'Industry Code'];
       transformedData = totalNoofNewPendingDSLReport.map(item => [
          item.industrial_unit_name,
          item.industrial_unit_code,
          ]);

    }else if(userLevel === "DIVISION LEVEL"){

      excelObjectData.firstRowMergeCells="A1:K1";
      excelObjectData.secondRowMergeCells="A2:K2";
      excelObjectData.thirdRowMergeCells="A3:K3";
      excelObjectData.fourthRowMergeCells="A4:K4";
      excelObjectData.fifthRowMergeCells="A5:K5";
      excelObjectData.headerEnglishColumns=[
     'District Name', 'Total Industry', 
      'Pending Industry', 'Pending Industry Codes', 'Submitted',
       'Submitted Industry Code', 'Completed Industry', 'Completed Industry codes', 
       'Rejected ', 'Rejected Industry codes'];

     transformedData = totalNoofNewPendingDSLReport.map(item => [
    `${item.district_name}`,
      item.total_industry,
      item.indusCounListArrayDataCount,
      [...(item.indusCounListArrayData || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.submittedIndustryListCount,
      [...(item.submittedIndustryListdata || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.acceptedIndustryListCount,
      [...(item.acceptedIndustryListdata || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.indusRejectcounListCount,
      getRejectedCodesText(item.indusRejectcounListdata),
  

    ]);
    //  Total
    transformedData[transformedData.length]=['TOTAL',total_industry,indusCounListArrayDataCount,'',submittedIndustryListCount,'',
      acceptedIndustryListCount,'',indusRejectcounListCount,'']
        

    }else{


        excelObjectData.firstRowMergeCells="A1:K1";
        excelObjectData.secondRowMergeCells="A2:K2";
        excelObjectData.thirdRowMergeCells="A3:K3";
        excelObjectData.fourthRowMergeCells="A4:K4";
        excelObjectData.fifthRowMergeCells="A5:K5";
        excelObjectData.headerEnglishColumns=[
        'Division Name', 'District Name', 'Total Industry', 
        'Pending Industry', 'Pending Industry Codes', 'Submitted',
         'Submitted Industry Code', 'Completed Industry', 'Completed Industry codes', 
         'Rejected ', 'Rejected Industry codes'];

       transformedData = totalNoofNewPendingDSLReport.map(item => [
        `${item.division_name}`,
        `${item.district_name}`,
        item.total_industry,
        item.indusCounListArrayDataCount,
        [...(item.indusCounListArrayData || [])]
          .map(v => (v ?? '').toString())
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
          .join(', '),
        item.submittedIndustryListCount,
        [...(item.submittedIndustryListdata || [])]
          .map(v => (v ?? '').toString())
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
          .join(', '),
        item.acceptedIndustryListCount,
        [...(item.acceptedIndustryListdata || [])]
          .map(v => (v ?? '').toString())
          .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
          .join(', '),
        item.indusRejectcounListCount,
        getRejectedCodesText(item.indusRejectcounListdata),
    
  
      ]);
       //  Total
       transformedData[transformedData.length]=['TOTAL','',total_industry,indusCounListArrayDataCount,'',submittedIndustryListCount,'',
      acceptedIndustryListCount,'',indusRejectcounListCount,'']
  
     }

   

    // Sheet-2: Rejected Reason details (flattened from rejectedReasons)
    const rejectedReasonRows = [];
    let sr = 1;
    (totalNoofNewPendingDSLReport || []).forEach((rec) => {
      const divName = rec?.division_name ?? '';
      const distName = rec?.district_name ?? '';
      const reasonsArr = Array.isArray(rec?.rejectedReasons) ? rec.rejectedReasons : [];
      reasonsArr.forEach((rr) => {
        const reasons = (Array.isArray(rr?.reasons) ? rr.reasons : [])
          .map((v) => String(v ?? '').trim())
          .filter((v) => v !== '' && v !== '0');
        if (reasons.length === 0) return;
        rejectedReasonRows.push([
          sr++,
          divName,
          distName,
          rr?.industry_code ?? rr?.industryCode ?? '',
          formatRejectedDate(rr?.date ?? rr?.rejected_date ?? rr?.rejectedDate ?? ''),
          reasons.join(', '),
          rr?.rejected_by ?? rr?.rejectedBy ?? '',
        ]);
      });
    });

    excelObjectData.excelRowData = transformedData;
    excelObjectData.sheets = [
      {
        sheetName: "IIPpendencyReport",
        headerEnglishColumns: excelObjectData.headerEnglishColumns,
        excelRowData: transformedData,
        firstRowMergeCells: excelObjectData.firstRowMergeCells,
        secondRowMergeCells: excelObjectData.secondRowMergeCells,
        thirdRowMergeCells: excelObjectData.thirdRowMergeCells,
        fourthRowMergeCells: excelObjectData.fourthRowMergeCells,
        fifthRowMergeCells: excelObjectData.fifthRowMergeCells,
        firstRowExportDate: excelObjectData.firstRowExportDate,
        secondRowText: excelObjectData.secondRowText,
        thirdRowText: excelObjectData.thirdRowText,
        fourthRowText: excelObjectData.fourthRowText,
        fifthRowText: excelObjectData.fifthRowText,
      },
      {
        sheetName: "Rejected Reason",
        firstRowMergeCells: "A1:G1",
        secondRowMergeCells: "A2:G2",
        thirdRowMergeCells: "A3:G3",
        fourthRowMergeCells: "A4:G4",
        fifthRowMergeCells: "A5:G5",
        firstRowExportDate: changeDateFormat(new Date()),
        secondRowText: `Index of Industrial Production, Uttar Pradesh`,
        thirdRowText: "Monthly Production Details",
        fourthRowText: `(Manufacturing Sector- Pendency Report)`,
        fifthRowText: `${monthName}-${yearName}`,
        headerEnglishColumns: ['S.No', 'Division Name', 'District Name', 'Industry Code', 'Date', 'Rejected Reason', 'Rejected By'],
        excelRowData: rejectedReasonRows,
      },
    ];

    generateExcelIIP(excelObjectData)
  };




  const handleGeneratePdf = () => {
    const heading1 =  changeDateFormat(new Date());
    const heading2 = "Index of Industrial Production, Uttar Pradesh";
    const heading3 = "Monthly Production Details";
    const heading4 = "(Manufacturing Sector- Pendency Report)";
    const heading5 = `${monthName}-${yearName}`;
    let headerEnglishColumns='';
    let pdfData='';
    let width='';
    let PDFFileName =generateFileName('IIP_PendencyReport');
    let total_industry = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.total_industry, 0)
    let indusCounListArrayDataCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.indusCounListArrayDataCount, 0)
    let indusRejectcounListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.indusRejectcounListCount, 0)
    let acceptedIndustryListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.acceptedIndustryListCount, 0)
    let submittedIndustryListCount = totalNoofNewPendingDSLReport.reduce((accum,item) => accum + item.submittedIndustryListCount, 0)
  


    if(userLevel === "DISTRICT LEVEL"){

      headerEnglishColumns = [
        'Industry Name', 'Industry Code'];
        pdfData = totalNoofNewPendingDSLReport.map(item => [
          item.industrial_unit_name,
          item.industrial_unit_code,
      ]);
      width= [300, 300];
      

  }else if(userLevel === "DIVISION LEVEL"){

          headerEnglishColumns = [
            'District Name', 'Total Industry', 
          'Pending Industry', 'Pending Industry Codes', 'Submitted',
            'Submitted Industry Code', 'Completed Industry', 'Completed Industry codes', 
            'Rejected ', 'Rejected Industry codes', 'Rejected Reason'];
            pdfData = totalNoofNewPendingDSLReport.map(item => [
          `${item.district_name}`,
            item.total_industry,
            item.indusCounListArrayDataCount,
            [...(item.indusCounListArrayData || [])]
              .map(v => (v ?? '').toString())
              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
              .join(', '),
            item.submittedIndustryListCount || '0',
            [...(item.submittedIndustryListdata || [])]
              .map(v => (v ?? '').toString())
              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
              .join(', '),
            item.acceptedIndustryListCount || '0',
            [...(item.acceptedIndustryListdata || [])]
              .map(v => (v ?? '').toString())
              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
              .join(', '),
            item.indusRejectcounListCount || '0',
            getRejectedCodesText(item.indusRejectcounListdata),
            getRejectedReasonsText(item.rejectedReasons),
          ]);

          width= [100, 100, 120, 150, 100, 150, 100, 150, 100, 150, 140];
           //  Total
        pdfData[pdfData.length]=['TOTAL',total_industry.toString(),indusCounListArrayDataCount.toString(),'',submittedIndustryListCount.toString(),'',
          acceptedIndustryListCount.toString(),'',indusRejectcounListCount.toString(),'','']

  }else{

     headerEnglishColumns = [
      'Division Name', 'District Name', 'Total Industry', 
     'Pending Industry', 'Pending Industry Codes', 'Submitted',
      'Submitted Industry Code', 'Completed Industry', 'Completed Industry codes', 
      'Rejected ', 'Rejected Industry codes', 'Rejected Reason'];
    pdfData = totalNoofNewPendingDSLReport.map(item => [
      `${item.division_name}`,
      `${item.district_name}`,
      item.total_industry,
      item.indusCounListArrayDataCount,
      [...(item.indusCounListArrayData || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.submittedIndustryListCount || '0',
      [...(item.submittedIndustryListdata || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.acceptedIndustryListCount || '0',
      [...(item.acceptedIndustryListdata || [])]
        .map(v => (v ?? '').toString())
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
        .join(', '),
      item.indusRejectcounListCount || '0',
      getRejectedCodesText(item.indusRejectcounListdata),
      getRejectedReasonsText(item.rejectedReasons),
    ]);

    width= [100, 100, 100, 120, 150, 100, 150, 100, 150, 100, 150, 140];
    //  Total
    pdfData[pdfData.length]=['TOTAL','',total_industry.toString(),indusCounListArrayDataCount.toString(),'',submittedIndustryListCount.toString(),'',
      acceptedIndustryListCount.toString(),'',indusRejectcounListCount.toString(),'','']
   
  }

    const pdfObjectData = {
        heading1,
        heading2,
        heading3,
        heading4,
        heading5,
        headerEnglishColumns,
        pdfData,
        width:width,
        PDFFileName,
        userLevel
    };
    generatePDFIIP(pdfObjectData);
};

const handleOpenRejectedDetails = (item) => {
  const rows = getRejectedDetailsRows(item?.rejectedReasons);
  if (rows.length === 0) {
    toast.info('Rejected details not available.', messages.COLOR_RED);
    return;
  }
  const divisionLabel = item?.division_name ? `${item.division_name}` : '';
  const districtLabel = item?.district_name ? `${item.district_name}` : '';
  const title = [divisionLabel, districtLabel].filter(Boolean).join(' - ') || 'Rejected Details';
  setRejectedModalTitle(title);
  setRejectedDetailsRows(rows);
  setShowRejectedModal(true);
};

const handleCloseRejectedDetails = () => {
  setShowRejectedModal(false);
  setRejectedDetailsRows([]);
};


const generateFileName=(fileName)=>{

  if (typeof divisionName === 'string' && divisionName !== '') {
    fileName = `${fileName}_${divisionName.replace(' ', '_')}`;
  }
  if (typeof districtName === 'string' && districtName !== '') {
    fileName = `${fileName}_${districtName.replace(' ', '_')}`;
  }
  if (typeof monthName === 'string' && monthName !== '') {
    fileName = `${fileName}_${monthName.replace(' ', '_')}`;
  }
  if (typeof yearName === 'string' && yearName !== '') {
    fileName = `${fileName}_${yearName.replace(' ', '_')}`;
   }

   return fileName;

}

const getFourDigitNumber=(arrayData)=>{
  let customItemCodes=[];
        for(let i=0;i<arrayData.length;i++){
                    
            if(arrayData[i].toString().length===1){
            customItemCodes.push('0000'+arrayData[i]);
            }
          
        }
 
      if(customItemCodes.length>0){
        arrayData=customItemCodes;
      }

    return arrayData;


}





  return (
    <>
      <ToastContainer />
      <GlobalLoading />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.GET_IIP_PENDENCY_REPORT : iipTitleData.en.GET_IIP_PENDENCY_REPORT }} />
              </h4>

              {userLevel === "HEAD QUARTER" && (
                <>
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>Division</label>
              <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                <option value="">ALL</option>
                {divisionList.length > 0 && divisionList.map((ele, index) => (
                  <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                    {ele.DIVISION_CODE}{'-'}{ele.DIVISION_NAME}
                  </option>
                ))}
              </select>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>District</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, index) => (
                    <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                      {ele.DISTRICT_CODE}{'-'}{ele.DISTRICT_NAME}
                    </option>
                  ))}
                </select>
              </div>
              </>
              )}


              {userLevel === "DIVISION LEVEL" && (
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>District</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, index) => (
                    <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                      {ele.DISTRICT_CODE}{'-'}{ele.DISTRICT_NAME}
                    </option>
                  ))}
                </select>
              </div>
               )}

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>
                <select value={monthName} onChange={handleMonthChange} name="month" className="form-select">
                  <option value="" >Select Month</option>
                  {getMonthList().map(month => (
                   <option key={month.value} value={month.value}>{month.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={handleYearChange} name="surveyYear" className="form-select">
                       <option value="">Select Year</option>
                        { getAllYears().map((year,index)=>(
                                <option value={year}>{year}</option>
                            ))
                        }
               </select>
              </div>



              <div className="col-xl-2 col-lg-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handlePendencyData} type="submit" className="btn btn_orange">Search</button>
              </div>

              <div className="col-xl-2 col-lg-12 mb-3 text-end">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <Link to="#" onClick={handleGenerateExcel} className="btn btn_green px-1 ms-auto"><img src="assets/images/excel.svg" className="me-2" alt="Excel" />Excel</Link>
                <Link to="#" onClick={handleGeneratePdf} className="btn btn_green ms-1 px-1"><img src="assets/images/pdf.svg" className="me-2" alt="PDF" />PDF</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="card mx-3 mb-3">
          <div className="card-body">

                 {/* DISTRICT level data */}
            
               { userLevel === "DISTRICT LEVEL" &&
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                      <th>Sr. No</th>
                      <th>Industry Name</th>
                      <th>Industry Code</th>
                      </tr>
                    </thead>
                    <tbody>
                    {totalNoofNewPendingDSLReport.length > 0 ? (
                        totalNoofNewPendingDSLReport.map((item, index) => {
                        return <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.industrial_unit_name}</td>
                            <td>{item.industrial_unit_code}</td>
                            </tr>
                   })
                  ) : (
                    ''
                  )}
                      </tbody>
                    </table>
                 }




               {/* HEAD QUARTER level data */}
              {(userLevel === "HEAD QUARTER" || userLevel === "DIVISION LEVEL" ) && 
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        { userLevel !== "DIVISION LEVEL" && <th>Division Name</th>}
                        <th>District Name</th>
                        <th>Total Industry</th>
                        <th>Pending Industry</th>
                        <th>Pending Industry Codes</th>
                        <th>Submitted Industry</th>
                        <th>Submitted Industry Code</th>
                        <th>Accepted Industry</th>
                        <th>Accepted Industry Code</th>
                        <th>Reject Industry</th>
                        <th>Rejected Industry Codes</th>
                        <th>Rejected Reason</th>
                  
                        </tr>
                    </thead>

                    <tbody>
                      {totalNoofNewPendingDSLReport.length > 0 ? (
                        totalNoofNewPendingDSLReport.map((item, index) => {
                         
                          
                        return <tr key={index}>
                            <td>{index + 1}</td>
                            { userLevel !== "DIVISION LEVEL" && <td>{item.division_name} ({item.division_code})</td>}
                            <td>{item.district_name} ({item.district_code})</td>
                            <td>{item.total_industry}</td>
                            <td>{item.indusCounListArrayDataCount}</td>
                            <td>{[...(item.indusCounListArrayData || [])]
                              .map(v => (v ?? '').toString())
                              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
                              .join(', ')}</td>
                            <td>{item.submittedIndustryListCount}</td>
                            <td>{[...(item.submittedIndustryListdata || [])]
                              .map(v => (v ?? '').toString())
                              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
                              .join(', ')}</td>
                            <td>{item.acceptedIndustryListCount}</td>
                            <td>{[...(item.acceptedIndustryListdata || [])]
                              .map(v => (v ?? '').toString())
                              .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }))
                              .join(', ')}</td>
                            <td>{item.indusRejectcounListCount}</td>
                            <td>{getRejectedCodesText(item.indusRejectcounListdata)}</td>
                            <td>
                              {Array.isArray(item.rejectedReasons) && item.rejectedReasons.some((r) => Array.isArray(r?.reasons) && r.reasons.some((x) => String(x ?? '').trim() !== '' && String(x ?? '').trim() !== '0')) ? (
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenRejectedDetails(item);
                                  }}
                                >
                                  View
                                </a>
                              ) : (
                                '-'
                              )}
                            </td>
                        
                          </tr>
                      })
                      ) : (
                        ''
                      )}
                    </tbody>
                  </table>
               }
           
          </div>
        </div>

      </div>

      {showRejectedModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{rejectedModalTitle}</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseRejectedDetails}></button>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Industry Code</th>
                          <th>Date</th>
                          <th>Rejected Reason</th>
                          <th>Rejected By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rejectedDetailsRows.map((row) => (
                          <tr key={`reject-${row.srNo}`}>
                            <td>{row.srNo}</td>
                            <td>{row.industryCode}</td>
                            <td>{row.rejectedDate}</td>
                            <td>{row.rejectedReason}</td>
                            <td>{row.rejectedBy}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseRejectedDetails}>Close</button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

export default GetPendencyReportHQ;
